<template>
  <v-container fluid>
    <v-layout row>
      <v-flex xs12 sm8 offset-sm2>
        <v-card>
          <v-responsive>
            <a
              href="https://www.leciem.com"
              target="_blank"
              rel="noopener noreferrer"
              class="logo-link"
            >
              <v-img :src="logoCiem" class="ma-auto" width="215" height="107" />
            </a>
          </v-responsive>
          <v-card-text>
            <v-form @keyup.native.enter="login">
              <v-checkbox
                :label="$t('user.details.roleCorrespondant')"
                v-model="$v.form.roleCorrespondant.$model"
              />

              <v-layout row mt-5>
                <v-text-field
                  :error-messages="$errors($v.form.login)"
                  v-model="$v.form.login.$model"
                  :label="
                    form.roleCorrespondant == true
                      ? $t('login.idCorrespondant')
                      : $t('login.idParticulier')
                  "
                  autofocus
                  autocomplete="off"
                  autocapitalize="none"
                />
              </v-layout>
              <v-text-field
                :error-messages="$errors($v.form.password)"
                v-model="$v.form.password.$model"
                :label="$t('login.password')"
                type="password"
                autocomplete="off"
              />
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-col>
              <v-btn :loading="loading" block color="primary" @click="login">{{
                $t('login.login')
              }}</v-btn>
              <br />
              <v-btn
                block
                outlined
                :to="{
                  name: 'forgotPassword',
                  params: { namespaceonly: true },
                }"
                >{{ $t('login.forgotpassword') }}
              </v-btn>
              <v-btn
                block
                outlined
                :to="{
                  name: 'forgotIdentifiant',
                  params: { namespaceonly: true },
                }"
                >{{ $t('login.forgotidentifiant') }}
              </v-btn>
              <br />
              <div class="assistance">
                <router-link
                  :to="{
                    name: 'assist',
                    params: { namespaceonly: true },
                  }"
                >
                  {{ $t('login.assistance') }}
                </router-link>
              </div>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import logoCiem from '@/assets/img/logo-ciem.png'
import { required } from 'vuelidate/lib/validators'
import { commit } from '@/utils/store'

export default {
  data() {
    return {
      logoCiem,
      form: {
        login: '',
        password: '',
        roleCorrespondant: false,
      },
      loading: false,
    }
  },
  mounted() {
    if (this.$auth.logged()) {
      this.$auth.logout()
    } else {
      commit('oauth/token', null)
      commit('oauth/user', null)
      commit('confirmauthentification/enCours', false)
    }
  },
  methods: {
    login() {
      this.$v.$touch()
      if (!this.$v.form.$invalid) {
        this.loading = true
        this.$auth
          .login(
            this.form.login,
            this.form.password,
            this.form.roleCorrespondant,
          )
          .finally(() => (this.loading = false))
      }
    },
  },
  validations: {
    form: {
      login: {
        required,
      },
      password: {
        required,
      },
      roleCorrespondant: {},
    },
  },
}
</script>

<style scoped>
.v-input.v-text-field {
  margin-bottom: 10px;
}
.assistance {
  text-align: center;
}
.assistance a {
  text-decoration: underline;
}
.logo-link {
  display: block;
  width: 215px;
  height: 107px;
  margin-left: auto;
  margin-right: auto;
}
</style>
